document.addEventListener("variant:changed", function (event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  const moneyFormat = window.MinimogSettings?.money_format || "{{ shop.money_format }}";
  const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let value = "";
    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = (cents / 100).toFixed(2);
        break;
      case "amount_no_decimals":
        value = Math.round(cents / 100);
        break;
      default:
        value = (cents / 100).toFixed(2);
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- DESKTOP ---------- */
  const desktop = document.querySelector(".product-block-group--price");
  if (desktop) {
    const salePriceEl = desktop.querySelector(".m-price-item--sale");
    const comparePriceEl = desktop.querySelector(".m-price-item--regular");
    const strikeEl = desktop.querySelector(".warnaDiskon");

    if (salePriceEl)
      salePriceEl.innerHTML = formatMoney(variant.price, moneyFormat);

    if (comparePriceEl)
      comparePriceEl.innerHTML = formatMoney(
        onSale ? variant.compare_at_price : variant.price,
        moneyFormat
      );

    if (strikeEl) {
      strikeEl.innerHTML = onSale
        ? formatMoney(variant.compare_at_price, moneyFormat)
        : formatMoney(variant.price, moneyFormat);
      strikeEl.style.display = onSale ? "" : "none";
    }

    const priceContainer = desktop.querySelector(".m-price");
    const regularBlock = desktop.querySelector(".m-price__regular");
    const saleBlock = desktop.querySelector(".m-price__sale");
    if (priceContainer) {
      priceContainer.classList.toggle("m-price--on-sale", onSale);
      priceContainer.classList.remove("m-price--no-compare");
    }
    if (regularBlock && saleBlock) {
      regularBlock.style.display = onSale ? "none" : "";
      saleBlock.style.display = onSale ? "" : "none";
    }

    const saleBadge = desktop.querySelector(".m-price__badge-sale");
    const saleAmount = desktop.querySelector("[data-saved-price]");
    if (saleBadge) {
      saleBadge.style.display = onSale ? "" : "none";
      if (onSale && saleAmount) {
        const percent = Math.round(
          ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
        );
        saleAmount.innerHTML = percent + "%";
      }
    }
  }

  /* ---------- MOBILE (sync with desktop) ---------- */
  const mobileSales = document.querySelector(".m-price__sale.mobile-sales");
  if (mobileSales) {
    const desktopSaleText =
      (desktop?.querySelector(".m-price-item--sale")?.innerHTML || "").trim();
    const desktopCompareText =
      (desktop?.querySelector(".warnaDiskon")?.innerHTML ||
        desktop?.querySelector(".m-price-item--regular")?.innerHTML ||
        "").trim();

    let mobileSaleEl = mobileSales.querySelector(".m-price-item--sale");
    if (!mobileSaleEl) {
      mobileSaleEl = document.createElement("span");
      mobileSaleEl.className = "m-price-item--sale";
      mobileSales.appendChild(mobileSaleEl);
    }

    let mobileCompareEl = mobileSales.querySelector(".warnaDiskon");
    if (!mobileCompareEl) {
      mobileCompareEl = document.createElement("s");
      mobileCompareEl.className = "warnaDiskon";
      mobileSales.appendChild(mobileCompareEl);
    }

    mobileSaleEl.innerHTML = desktopSaleText;
    mobileCompareEl.innerHTML = desktopCompareText;
    mobileCompareEl.style.display = onSale ? "" : "none";
  }
});